import { ReligiousInfoVO } from 'mds-ui/app/shared/model/consecratedPerson';
import { ApiResponse } from 'mds-ui/app/shared/model/apiresponse';

export class PersonInfo {
    id: number;
    prefix: number;
    firstName: string;
    lastName: string;
    preferredFirstName: string;
    preferredLastName: string;
    middleName: string;
    gender: string;
    sufix: number;
    dob: Date;
    primaryLanguage: string;
    image: File;
    isActive: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
    addressList: AddressVO[];
    personAssociationTypeList: PersonAssociationTypeVO[];
    phoneHistoryList: PhoneHistoryVO[];
    emailHistoryList: EmailHistoryVO[];
    religiousInfoVO: ReligiousInfoVO;
    consecratedMenVO: ConsecratedMenVO[];
    consecratedWomenVO: ConsecratedWomenVO[];
    image1: any;
    community: string;
    maritalStatus: string;
    ssn: string;
    applicantId: number;
    birthPlace: string;
  birthCity: string;
  birthState: string;
  birthCountry: string;
    deceasedDate: Date;
    deceasedPlace: string;
    driversLicense:string;
    ageRange: string;
    // language: string;
    // maritalState: string;
    // consecratedLifeType: string;
    // houseName: string;
    // placeOfMinistry: string;
    // community: string;
    selected: boolean;
    associateId: string;
    adpImport: any;
}

export class AddressVO {
    id: number;
    orgId: string;
    orgName: string;
    personId: number;
    addressType: string
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zip: string;
    zipExtn: string;

    isActive: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;

}
export class PhoneHistoryVO {
    id: number;
    personId: number;
    category: string;
    phoneNumber: string;
    extension: number;

    isActive: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
}

export class PersonAssociationTypeVO {
    id: number;
    personId: number;
    type: number;
    isActive: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
    name: string;
}

export class EmailHistoryVO {
    id: number;
    personId: number;
    category: string;
    email: string;
    isActive: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
}
export class ConsecratedMenVO {
    id: number;
    personId: number;
    community: string;
    consecratedLifeType: string;
    notes: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
}
export class ConsecratedWomenVO {
    id: number;
    personId: number;
    community: string;
    consecratedLifeType: string;
    notes: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
}

export class PersonResponse {
    apiResponseVO: ApiResponse;
    personInfoVOList: PersonInfo;
}
export class PersonInfoResponse {
    apiResponseVO: ApiResponse;
    personInfoVOList: PersonInfo[];
}

export class PriestsearchVO {
    associateType: string[];
}

export class ConsecratedPersonVO {

    id: number;
    personId: number;
    consecratedLifeType: number;
    houseName: number;
    community: number;
    notes: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;


}
export class PersonInfoSearchVO {
    id: number;
    firstName: string;
    lastName: string;
    middleName: string;
    pageSize: number;
    isActive: string;
    pageNo: number;
    dob: Date;
}
export class ConsecratedPersonDetails {
    community: string;
    houseName: string;
    consecratedLifeTypeName: string;
    localSuperior: string;
    majorSuperior: string;
    status: string;
    address: string;
    state: string;
    city: string;
    zip: string;
    zipExtn: string;
    phone: string;
    phoneExtn: string;
    communityCode: string;
    email: string;
    majorSuperiorEmail: string;
    statusInDioceses: string;
    // statusInDioceses: StatusInDiocesesVO;
    // consecratedLifeType: ConsecratedLifeTypeVO;
    // houseName: HouseNameVO;
    // community: CommunityVO;
    // localSuperiorId: LocalSuperiorVO;
    // majorSuperiorId: MajorSuperiorVO;

}
export class ErrorAddress {
    AddressType: string="";
    Zip: string="";
    State: string="";
    ZipPerfix: string="";
    addressLine1: string="";
    city: string="";
    homeFlag: boolean;
}
export class StatusInDiocesesVO {
    id: number;
    statusInDioceses: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
}
export class HouseNameVO {
    id: number;
    houseName: string;
    address: string;
    state: string;
    city: string;
    zip: string;
    isActive: string;
    zipExtn: number;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;

}
export class CommunityVO {
    id: number;
    community: string;
    communityCode: string;
    isActive: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;

}
export class LocalSuperiorVO {
    id: number;
    name: string;
    email: string;
    isActive: string;
    phone: string;
    phoneExtn: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;

}
export class ConsecratedLifeTypeVO {
    id: number;
    consecratedLifeType: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;

}
export class MajorSuperiorVO {
    id: number;
    name: string;
    email: string;
    isActive: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;

}